import styled from '@emotion/styled'
import {theme} from '../../accountManagement/theme'

export const Wrapper = styled.div`
  background: ${theme.colors.bg.brandAlt};
  border: 1px solid ${theme.colors.border.alt};
  border-radius: ${theme.radii.xl};
  padding: ${theme.space[2.5]};
  display: flex;
  flex-direction: column;
  gap: ${theme.space[3]};
`

export const TopBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${theme.space[4]};
`

export const CardsGrid = styled.div`
  display: grid;
  /* auto-fit collapses empty tracks, so a lone card stretches across the row.
     Callers that can show fewer cards than usual (1:Many, per country) pass
     fixedColumns to keep cards card-sized; everyone else keeps auto-fit. */
  grid-template-columns: ${({fixedColumns}) =>
    fixedColumns
      ? `repeat(${fixedColumns}, minmax(0, 1fr))`
      : 'repeat(auto-fit, minmax(220px, 1fr))'};
  gap: ${theme.space[3]};
`
